import Vue from "vue";
import { TRANSLATABLE_PAYMENT_STATES } from "../enum/online_purchase";

Vue.filter("payment_state", value => {
  let payment_state = TRANSLATABLE_PAYMENT_STATES.find(x => x.key === value);
  if (!payment_state) {
    return null;
  }
  return payment_state.translation;
});
